import { DetailBooking } from 'components/detail/view/DetailBooking';
import { DetailCards } from 'components/detail/view/DetailCards';
import { DetailHeader } from 'components/detail/view/DetailHeader';

import { DetailFooter } from 'components/site/modals/DetailModal/DetailFooter';
import { SidebarModalWrapper } from 'components/site/modals/SidebarModalWrapper/SidebarModalWrapper';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';
import { CtxView } from 'session/ctxView';

export const DetailModal = (): JSX.Element => {
    const ctxModal = useContext(CtxModal);
    const ctxView = useContext(CtxView);

    const connectedMarkers = ctxModal.detailModal?.detail?.connectedMarkers ?? [];

    const onClose = () => {
        ctxModal.setDetailModal(null);
    };

    if (!ctxModal?.detailModal?.id) {
        return null;
    }

    const content =
        ctxModal.detailModal?.id === ctxModal.detailModal?.detail?.storyId ? (
            <>
                <DetailHeader header={ctxModal.detailModal.detail.header} />
                {ctxModal.detailModal.detail.cards?.length > 0 && (
                    <DetailCards cards={ctxModal.detailModal.detail.cards} />
                )}
                {connectedMarkers[0] && (
                    <DetailBooking markerId={connectedMarkers[0].worldMapMarkerId} />
                )}
            </>
        ) : (
            <></>
        );

    const footer = ctxView?.customPageConfig?.hideMarkerDetailActions ? <></> : <DetailFooter />;

    return (
        <SidebarModalWrapper
            content={content}
            footer={footer}
            onClose={onClose}
            background={'#f1f1f1'}
        />
    );
};
